import React from "react";
import { Modal, ModalBody, ModalFooter, Button } from "kepler";
import { parseMessages } from '../../../utilityHelper';

const propertyInfo = parseMessages('ppcc/confirmation/confirmation-home');

export default class WhatIsTechSoup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
			modalIsOpen: this.props.isOpen || false
        };
		this.closeModal = this.closeModal.bind(this);
    }

    componentWillReceiveProps(nextProps) {
		this.setState({
				modalIsOpen: nextProps.isOpen
		});
   }

	closeModal(){
		this.setState({
			modalIsOpen: false
		});
	}

    render() {
	        return (
        			<Modal
						isOpen={this.state.modalIsOpen}
						onCancel={this.closeModal}
						backdropClosesModal={true}
						type="default"
					>
						<ModalBody>
							<h3>{propertyInfo.confirm.whatistechsoup}</h3>
							<p className="vx_text-body-md">{propertyInfo.modal.p1}</p>
							<p className="vx_text-body-md">{propertyInfo.modal.p2}</p>
							<p className="vx_text-body-md">{propertyInfo.modal.p3}</p>
							<p className="vx_text-body-md">{propertyInfo.modal.p4}</p>
							<Button type="primary" id="modelClose" onClick={this.closeModal}>{propertyInfo.modal.gotit}</Button>
						</ModalBody>
						<ModalFooter/>
					</Modal>
	        )
    }
};



// WEBPACK FOOTER //
// ./ppcc/confirmation/components/whatIsTechSoupModal.js